import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/common/TextField';

class NumberField extends PureComponent {
  state = {
    value: '',
    isChange: false,
  };

  normalizeFloatString = (v) => {
    if (!v) return v;

    let anyPointer = false;

    let res = '';

    for (let i = 0; i < v.length; i ++) {
      let symbol = v[i];
      if (symbol === '0'
        || symbol === '1'
        || symbol === '2'
        || symbol === '3'
        || symbol === '4'
        || symbol === '5'
        || symbol === '6'
        || symbol === '7'
        || symbol === '8'
        || symbol === '9'
      ) {
        res = res + symbol;
      }

      if (symbol === '.'  || symbol === ',') {
        if (!anyPointer) {
          res = res + symbol;
          anyPointer = true;
        }
      }

    }

    return res;
  };


  handlerOnChange = (v) => {
    const { range, onChange } = this.props;
    v = this.normalizeFloatString(v);

    if (onChange) {
      if (v) {
        let arrayValue = v.split('.');
        if (arrayValue.length <= 1) arrayValue = v.split(',');

        if (arrayValue.length > 0 && arrayValue[0]) {
          arrayValue[0] = parseInt(arrayValue[0]).toString();
          v = arrayValue.join('.');
        }

        if (range) {
          if (arrayValue.length > 1) {
            if (range && arrayValue[1].length > range) {
              arrayValue[1] = arrayValue[1].slice(0, range);

              v = arrayValue.join('.');
            }
          }
        }
      }

      this.setState({value: v, isChange: true});

      if (v && v[v.length - 1] === '.') v = v.slice(0, v.length-1);
      onChange(parseFloat(v));
    }
  };

  getValueText = () => {
    const { value: propsValue } = this.props;
    const { value: stateValue } = this.state;

    if ((propsValue || propsValue === 0) && (stateValue || stateValue === 0)) {
      const pValue = parseFloat(propsValue);
      const sValue = parseFloat(stateValue);

      if (pValue === sValue) return stateValue;
    }

    return propsValue;
  };

  handlerOnBlur = () => {
    let {onChange, value: propsValue} = this.props;
    let {value: v} = this.state;

    if (v) {
      let any = false;
      if (v[0] === '.') {
        v = '0' + v;
        any = true;
      }

      if (v[v.length - 1] === '.') {
        v = v.slice(0, v.length-1);
        any = true;
      }

      if (any) {
        this.setState({value: v});

        if (propsValue !== v) {
          onChange(parseFloat(v));
        }
      }
    }
  };

  render() {
    const {
      debounce,
      style,
      placeholder,
      className
    } = this.props;

    const value = this.getValueText();

    return (
      <TextField
        className={className}
        onBlur={this.handlerOnBlur}
        debounce={debounce}
        style={style}
        value={value}
        placeholder={placeholder}
        onChange={this.handlerOnChange}
      />
    );
  }
}

NumberField.propTypes = {
  className: PropTypes.string,
  debounce: PropTypes.number,
  range: PropTypes.number,
  style: PropTypes.object,
  value: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default NumberField;


// WEBPACK FOOTER //
// ./src/components/common/NumberField/NumberField.jsx